import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ANIMATION_FUNCTION } from "@similarweb/ui-components";

const THIN_HEIGHT = 6;
const BOLD_HEIGHT = 10;

export const StyledOnboardingHubProgress = styled.div<{ isBold: boolean }>`
    width: 100%;
    position: relative;
    height: ${({ isBold }) => (isBold ? BOLD_HEIGHT : THIN_HEIGHT)}px;
    border-radius: ${({ isBold }) => (isBold ? BOLD_HEIGHT : THIN_HEIGHT)}px;
    background: ${colorsPalettes.bluegrey[300]};
`;
export const StyledOnboardingHubProgressLine = styled.div<{ progress: number; isBold: boolean }>`
    width: ${({ progress }) => progress}%;
    height: ${({ isBold }) => (isBold ? BOLD_HEIGHT : THIN_HEIGHT)}px;
    border-radius: ${({ isBold }) => (isBold ? BOLD_HEIGHT : THIN_HEIGHT)}px;
    background: ${colorsPalettes.mint[400]};
    transition: width 200ms ${ANIMATION_FUNCTION};
`;
